module.exports = __webpack_public_path__ + "static/media/dog.763223cf.png";